import { render, staticRenderFns } from "./QuestionGroupDetail.vue?vue&type=template&id=74f56796&scoped=true&"
import script from "./QuestionGroupDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f56796",
  null
  
)

export default component.exports